module.exports = __webpack_public_path__ + "static/media/officeluv-full-logo-teal.ffa0231a.svg";